import { useSyncExternalStore } from "react";
import store, { RootState } from "redux/store";

type Selector<T> = (state: RootState) => T;

const useReduxState = <Selected>(
  selector: Selector<Selected>,
  equalityFn: (a: Selected, b: Selected) => boolean = Object.is
): Selected => {
  let lastSelectedState: Selected = selector(store.getState());

  return useSyncExternalStore(store.subscribe, () => {
    const nextState = selector(store.getState());
    if (!equalityFn(lastSelectedState, nextState)) {
      lastSelectedState = nextState;
    }

    return lastSelectedState;
  });
};

export default useReduxState;
